export const baseUrlConfig = {
  development: 'https://api.staging.voltmoney.in',
  production: 'https://api.voltmoney.in',
  testing: 'https://api.testing.voltmoney.in',
};
console.log('ENVIROMENT', process.env.NODE_ENV);
export const baseUrl = baseUrlConfig['production'];

export const endpoints = {
  refreshToken: '/api/client/refresh/token',
  getAuthToken: '/api/client/las/customer/getAuthToken',
  generateLoginOTP: '/api/client/auth/requestOtp/v2',
  verifyLoginOTP: '/api/client/auth/verifyOtp/',
  requestEmailOTP: '/api/client/auth/requestOtp/email',
  verifyEmailOTP: '/api/client/auth/verifyOtp/email',
  userInfo: '/app/borrower/user',
  pledgeData: '/app/borrower/application/asset/pledge/details/',
  accountAttributes: '/app/borrower/accountAttributes/',
  verifyPan: '/app/borrower/application/kyc/pan/panVerify',
  resetPan: '/app/borrower/application/kyc/pan/panReset/',
  showEnableLimit: '/app/borrower/application/enable/edit/limit/',
  editLimitRoute: '/app/borrower/application/edit/limit/',
  platformDetailsApi: '/app/pf/details/',
  getLenderInfo: '/app/borrower/application/creditApplication/lender/info/',
  logout: '/api/client/logout',
};


export const amplitudeConfig = {
  STAGING: '0db77c455f0b7518a30b95598a6e5e5b',
  TEST_STAGING: '0db77c455f0b7518a30b95598a6e5e5b',
  QA_STAGING: '0db77c455f0b7518a30b95598a6e5e5b',
  BORROWER_PRODUCTION: 'f15bbbe2415bf57272c15694aa4358ec',
}
